/* eslint-disable import/prefer-default-export */
/**
 * * Adapted from the original function in the PDP Backbone code
 *
 * TODO clarify the API contract and refactor the code.
 * @param { import('@common-vue/media-card-large/src/composables/useUpc/types').UseUpc.Upc } upc
 * @returns {string}
 */
export const getHolidayMessage = (upc) => {
  if (!upc) return 'Shipping:NA|Pickup:NA';
  const { holidayMessageEligible, holidayMessages, availability } = upc;
  if (holidayMessageEligible) {
    const holidayShipMessage = holidayMessages.beforeStandardCutoff || false;
    const holidayPickupMessage = availability.holidayMessages.beforeBossCutoff;
    /**
     * No idea about API contract. I've found examples of holidayShipMessage correct values.
     * I've copied the same logic for holidayPickupMessage as for Backbone PDP code.
     * Especially, inconsitent use of 'PickUp:NA' and 'Pickup:NA' strings makes me think that the API contract is not clear.
     */
    return `${holidayShipMessage ? 'Shipping:BH' : 'Shipping:AH'}|${holidayPickupMessage ? 'Pickup:BH' : `${(holidayPickupMessage !== undefined) ? 'Pickup:AH' : 'PickUp:NA'}`}`;
  }
  return 'Shipping:NA|Pickup:NA';
};
